import TitleInfoSubList from "./titleInfoSubList";
export default TitleInfoSubList;